import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from '../../shared';
import { CmsEventContainerModel } from '../../../../../../models/aggregates/cms/event-calendar';
import { Observable } from 'rxjs';
import { CalendarEventListingModel } from '../../../../../../models/aggregates/cms/event-calendar/cms-calendar-event-listing.model';

@Injectable({providedIn: 'root'})

export class CmsEventHdrService extends BaseApiPublicLoginTemplateService<CmsEventContainerModel, CmsEventContainerModel, CmsEventContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-events/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-events/backoffice-ep';
    this.httpClient = http;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-events/' + BaseApiTemplateService.PUBLIC_EP;
  }

  deleteEvent(guid: string, deleteType: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      this.apiUrl + '/' + guid + '?delete_type=' + deleteType,
      this.getHttpHeader(visa)
    );
  }
  
  public getEventsByCriteria(
    pagination: Pagination,
    visa: ApiVisa
  ): Observable<PagingResponseModel<CmsEventContainerModel>> {
    const endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-events/custom/backoffice-ep';
    let apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-events/custom/backoffice-ep';
    if (visa.api_domain_url) {
      apiUrl = visa.api_domain_url + endpoint_path;
    }
    const UrlByCriteria =
      apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<CmsEventContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
  getEventsByLoginParticipant(employeeHdrGuid: string, visa: ApiVisa): Observable<PagingResponseModel<CalendarEventListingModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'calendar-events/events-by-participant/login-ep';
    }
    const UrlByCriteria =
    this.apiUrl + "/query?login_subject_guid=" + employeeHdrGuid  
    return this.httpClient.get<PagingResponseModel<CalendarEventListingModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}